import { render, staticRenderFns } from "./TheCarousel.vue?vue&type=template&id=95dbe336&scoped=true&"
import script from "./TheCarousel.vue?vue&type=script&lang=js&"
export * from "./TheCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheCarousel.vue?vue&type=style&index=0&id=95dbe336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dbe336",
  null
  
)

export default component.exports